import { BehaviorSubject } from 'rxjs'
import { RxJS } from './RxJS'
import { SidebarMenuItems } from '../../constants/ReactRouter/Header/Constants'
import { RxJSStateDefinable } from '../Types/Types'

const reportingMenuFavouritesSubject: BehaviorSubject<Definable<SidebarMenuItems[]>> = new BehaviorSubject<
    Definable<SidebarMenuItems[]>
>([])

RxJS.reportingMenuFavourites = RxJS.reportingMenuFavourites ?? {
    subject: reportingMenuFavouritesSubject,
    observable: reportingMenuFavouritesSubject.asObservable(),
    announce: (data?: SidebarMenuItems[]): void => reportingMenuFavouritesSubject.next(data)
}

export const reportingMenuFavourites$: RxJSStateDefinable<SidebarMenuItems[]> = RxJS.reportingMenuFavourites
